import {
  EmergencyUrgency as EmergencyUrgencyIcon,
  ScheduledTransfers as ScheduledTransfersIcon,
  TrainingCourses as TrainingCoursesIcon,
  HomeCare as HomeCareIcon,
  PediatricDivision as PediatricDivisionIcon,
  Area as AreaIcon,
  CoberturaEventos as CoberturaEventosIcon,
  Pgm as PgmIcon,
  Doctor as DoctorIcon,
  Contributor as ContributorIcon,
} from '../components/Icons';

const info_products = [
  {
    value: 1,
    label: "Emergencias & Urgencias",
    selectLocality: true,
    withOffice: true,
    onlyEccoSA: true,
    isProductPGM: false,
    onlyThisProvinces: ["B", "BC", "X", "M", "Q", "QS", "A", "S", "T"],
    id: "emergencias-urgencias",
    iconPath: '/assets/icons/productos/emergency-urgency.svg',
    icon: EmergencyUrgencyIcon,
    borderRadius: 'not-top-right'
  },
  {
    value: 2,
    label: "Traslados",
    selectLocality: false,
    withOffice: false,
    onlyEccoSA: false,
    isProductPGM: false,
    onlyThisProvinces: null,
    id: "traslados",
    iconPath: '/assets/icons/productos/scheduled-transfers.svg',
    icon: ScheduledTransfersIcon,
    borderRadius: 'not-bottom-left'
  },
  {
    value: 3,
    label: "Cursos de capacitación",
    selectLocality: false,
    withOffice: true,
    onlyEccoSA: true,
    isProductPGM: false,
    onlyThisProvinces: null,
    id: "capacitacion",
    iconPath: '/assets/icons/productos/training-courses.svg',
    icon: TrainingCoursesIcon,
    borderRadius: 'not-bottom-right'
  },
  {
    value: 4,
    label: "Cuidados domiciliarios",
    selectLocality: false,
    withOffice: false,
    onlyEccoSA: false,
    isProductPGM: false,
    onlyThisProvinces: null,
    id: "cuidados-domiciliarios",
    iconPath: '/assets/icons/productos/home-care.svg',
    icon: HomeCareIcon,
    borderRadius: 'not-top-left'
  },
  {
    value: 5,
    label: "División pediátrica",
    selectLocality: false,
    withOffice: true,
    onlyEccoSA: true,
    isProductPGM: false,
    onlyThisProvinces: ["X","S"],
    id: "division-pediatrica",
    iconPath: '/assets/icons/productos/pediatric-division.svg',
    icon: PediatricDivisionIcon,
    borderRadius: 'not-bottom-left'
  },
  {
    value: 7,
    label: "Área protegida",
    selectLocality: false,
    withOffice: true,
    onlyEccoSA: true,
    isProductPGM: false,
    onlyThisProvinces: ["B", "BC", "X", "M", "Q", "QS", "A", "S", "T"],
    id: "area-protegida",
    iconPath: '/assets/icons/productos/protected-area.svg',
    icon: AreaIcon,
    borderRadius: 'not-bottom-right'
  },
  {
    value: 8,
    label: "Cobertura de eventos",
    selectLocality: false,
    withOffice: false,
    onlyEccoSA: false,
    onlyThisProvinces: null,
    isProductPGM: false,
    id: "cobertura-eventos",
    iconPath: '/assets/icons/productos/event-coverage.svg',
    icon: CoberturaEventosIcon,
    borderRadius: 'not-bottom-right'
  },
  {
    value: 9,
    label: "Petróleo, Gas y Minería",
    selectLocality: false,
    withOffice: false,
    onlyEccoSA: false,
    onlyThisProvinces: null,
    isProductPGM: true,
    id: "ecco-pgm",
    iconPath: '/assets/icons/productos/pgm.svg',
    icon: PgmIcon,
    borderRadius: 'not-top-left'
  },
  {
    value: 10,
    label: "Medicina Laboral",
    selectLocality: false,
    withOffice: false,
    onlyEccoSA: false,
    isProductPGM: false,
    onlyThisProvinces: null,
    id: "medicina-laboral",
    iconPath: '/assets/images/empresas/laboral/icon-person.svg',
    icon: DoctorIcon,
    borderRadius: 'not-bottom-left'
  },
  {
    value: 11,
    label: "Control de Ausentismos",
    selectLocality: false,
    withOffice: false,
    onlyEccoSA: false,
    isProductPGM: false,
    onlyThisProvinces: null,
    id: "control-de-ausentismos",
    iconPath: '/assets/images/empresas/service-icon-ausentismo.svg',
    icon: ContributorIcon,
    borderRadius: 'not-bottom-right'
  },
];

export default info_products;
